import { useState, useCallback } from "react";
import { authenticatedGet } from "../../api/authenticatedFetch";

const ENDPOINT = "/api/v1/forecast-predictability/flag-readiness";

// useFlagReadiness returns flag-readiness data ON DEMAND (not on mount).
// The `check` function triggers the evaluation; the endpoint is slow so we
// never call it automatically.
//
// Returns: { flags, loading, error, check }
export function useFlagReadiness() {
  const [flags, setFlags] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const check = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await authenticatedGet(ENDPOINT);
      // Support both { flags: [...] } and raw array responses
      const flagList = res && Array.isArray(res.flags) ? res.flags : (Array.isArray(res) ? res : []);
      setFlags(flagList);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  return { flags, loading, error, check };
}
